import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Typography } from '@mui/material';

const LoadingBackDrop = ({open, text})=>{

    return (
       <Backdrop 
       //keepMounted={true}
        sx={{ 
          backgroundColor:'rgba(51, 51, 51, .5)',
           zIndex: 111 }}
          open={open}
        
        
      >
        <CircularProgress 
          size={88}
          thickness={6}
          color="primary" />
          {
              Boolean(text) && <Typography variant='h2' sx={{color:'#0000ee'}}>text</Typography>
          }
          
      </Backdrop>

    )

}

export default LoadingBackDrop